import { IChildProp } from '@intelligence/components/Form/type';

const MOBILE_OVERLAP: IChildProp[] = [{
  enumKey: 'overlapMetrics',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    label: 'MAU',
    labelKey: 'dbi_mau',
    value: 'mau',
    isDefault: true,
  },
  {
    label: 'Cross Mobile Usage',
    labelKey: 'dbi_cross_mobile_usage',
    value: 'cross_mobile_usage',
    isDefault: true,
  },
  {
    label: 'Cross Mobile Affinity',
    labelKey: 'dbi_cross_mobile_affinity',
    value: 'cross_mobile_affinity',
    isDefault: true,
  }],
}, {
  enumKey: 'basicInformation',
  enumTargetType: 'downloadMainCategory',
  type: 'checkboxGroup',
  children: [{
    enumKey: 'hasCompany',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasGenre',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRelease',
    enumTargetType: 'downloadBasicInfo',
  }, {
    enumKey: 'hasRegion',
    enumTargetType: 'downloadBasicInfo',
  }],
}, {
  enumKey: 'dataCalculation',
  enumTargetType: 'downloadMainCategory',
  type: 'subForm',
  className: 'form-item--top-18',
  children: [{
    enumKey: 'overlapPlatformSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [{
      enumKey: 'specialAppStore',
      enumTargetType: 'platformMobile',
      isDefault: true,
    }, {
      enumKey: 'specialGooglePlay',
      enumTargetType: 'platformMobile',
      isDefault: true,
    }]
  }, {
    enumKey: 'timePickerSettings',
    enumTargetType: 'downloadMainCategory',
    type: 'datePicker',
    msgKey: 'dbi_selected_multiple_months',
  }, {
    enumKey: 'countrySettings',
    enumTargetType: 'downloadMainCategory',
    type: 'mutipleCountry',
    msgKey: 'dbi_selected_multiple_country',
  }, {
    enumKey: 'ratio',
    enumTargetType: 'downloadMainCategory',
    type: 'switch',
    isDefault: true,
  }]
}, {
  enumKey: 'dataAmount',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportAllData',
    enumTargetType: 'downloadOther',
    msgKey: 'dbi_export_all_tip',
  }, {
    enumKey: 'selectTop',
    enumTargetType: 'downloadOther',
  }]
}, {
  enumKey: 'selectTop',
  enumTargetType: 'downloadMainCategory',
  type: 'inputNumber',
  // 默认值，带?为变量传入，不带为正常值
  defaultValue: '?additionalFields:initialSelectTop',
  condition: 'dataAmount:top',
}, {
  enumKey: 'fileFormat',
  enumTargetType: 'downloadMainCategory',
  type: 'radio',
  children: [{
    isDefault: true,
    enumKey: 'exportExcel',
    enumTargetType: 'downloadOther',
  }, {
    enumKey: 'exportCSV',
    enumTargetType: 'downloadOther',
  }],
}];

export default {
  mobileOverlap: MOBILE_OVERLAP
};
